import { useAuthQuery } from '@/hooks/use-auth-query'
import { rewardsApi } from '@/api'

function useGetRewardBalance(period) {
  return useAuthQuery({
    queryKey: ['reward_balance', period],
    queryFn: async () => rewardsApi.getRewardsSummary(period),
    refetchOnWindowFocus: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
  })
}

export default useGetRewardBalance
